import React from "react";
import "./../Homepage.css";
import "./weekly.css";

import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';

import API_endpoint from './../photos/electronic-programming/API_endpoint.webp';
import connection from './../photos/electronic-programming/connection.webp';
import esp32 from './../photos/electronic-programming/esp32.webp';
import example_code from './../photos/electronic-programming/example_code.webp';
import moved_permanently from './../photos/electronic-programming/moved_permanently.webp';
import multi_site from './../photos/electronic-programming/multi_site.webp';
import no_connection from './../photos/electronic-programming/no_connection.webp';
import status_codes from './../photos/electronic-programming/status_codes.webp';
import whoami from './../photos/electronic-programming/whoami.webp';
import cleopage from './../photos/electronic-programming/cleo-page.webp';
import esp32_pins from './../photos/electronic-programming/esp32_pins.webp';
import led_on from './../photos/electronic-programming/led_on.webp';
import led_off from './../photos/electronic-programming/led_off.webp';
import led_setup from './../photos/electronic-programming/led_setup.webp';
import led_loop from './../photos/electronic-programming/led_loop.webp';
import off_code from './../photos/electronic-programming/off_code.webp';

const codeSlide1 = [{image: no_connection, caption: "Code and Serial messages with no connection"},
                     {image: status_codes, caption: "WiFi status codes to debug connection"},
                     {image: connection, caption: "Code and Serial messages once conneciton successful"},
                     {image: moved_permanently, caption: "301 error code with HTTP header"},
                     {image: whoami, caption: "Successful site ping after bug fixes"},];
const codeSlide2 = [{image: esp32_pins, caption: "ESP32 with soldered pins"},
                     {image: led_setup, caption: "Setup code for LED operation"},
                     {image: led_loop, caption: "Logic for turning LED on and off"},
                     {image: led_on, caption: "LED on when site is live"},
                     {image: off_code, caption: "Fake endpoint added to test unresponsive site"},
                     {image: led_off, caption: "LED off when site is unresponsive"}];

const Week3 = (props) => {
    return (
      <div className="HP-module">
        <div className="HP-subtitle">Week 3</div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            For my next project I've been tasked with programming a microcontroller to do <span style={{fontStyle:"italic"}}>something</span>. 
            After being given a list of possible microcontrollers to use and their respective pros and cons, I honed in on the ESP32-C3 XIAO board, 
            specificlly because of it's low barrier to entry and it's wifi capabilities. When we were introduced to our assignment, program a microcontroller 
            which we can communicate to over serial connection, I immediately thought of a small WiFi enabled task that would be very helpful in 
            my day to day life: a website checker! This would be fairly useless to most people, however I currently run a startup, and part of that 
            startup is a website. Occasionally, for various reasons, the website goes down, so I set out to program the microcontroller to ping my 
            website once a minute and tell me if it is up/down. So, with my motivation set, I gathered my board and a radio antenna for signal strength 
            and began looking through the datasheet to figure out how it operates.
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={cleopage} className="HP-medPhoto" />
              <div className="HP-caption">My website for my company</div>
            </div>
            <div className="HP-photoObject">
              <img src={esp32} className="HP-medPhoto"/>
              <div className="HP-caption">The esp32 with a radio antenna</div>
            </div>
          </div>
        </div>
        <div className="HP-body">
          The ESP32 datasheet outlined the inner functionality of the microcontroller, which is an incredibly complex and capable chip. With so many 
          features, it was important to comb through the datasheet for the important and relevant information, as reading the entire thing is infeasible 
          for a human. I learned about the memory types, usage, processor architecture, chip offerings, and more to allow me to understand where to begin 
          my development. My next step was to talk to the board over serial conection, which I decided to do in Arduino because of my familiarity with C 
          and the ease of use with the Arduino toolchain. I went into the Arduino library settings and added a library for ESP32 boards, which included our 
          ESP32-C3 XIAO board. Next, I burned the bootloader to the chip to allow communication and program upload, and finally 
          uploaded our provided "hello.ino" code and was happy to see it worked out of the box. I could now talk to the microcontroller!
        </div>
        <div className="HP-flex">
          <div className="HP-body HP-half">
            Now that I could upload programs and communicate over serial, it wa time to configure the WiFi for the microcontroller. Thankfully, Arduino comes 
            built in with many examples for using your device. I opened two of these programs: one demonstrated a simple WiFi connection, the other how to 
            make a http request over the WiFi once connected. I used this code as a starting point, and modified it to connect to my MIT WiFi and make a 
            GET request to my website, which would hopefully respond with a 200 status code if successful. I ran into a couple of bugs here. First I could 
            not get the WiFi to connect. I troubleshooted this by printing out the WiFi status code, an object build into the ESP32 WiFi.h module on Arduino. 
            This wasn't helpful at first, as it only responded in numbers, so I found the translation to what the codes meant online. This revealed that 
            the network wasn't being found, which led to me realizing I had spelled it wrong in my code (annoying strict-casing). Now that I could connect 
            to WiFi, I still could not reach my website. Instead I found a 301 status code, with the message that my site had moved permanently. This was 
            due to using HTTP instead of HTTPS, which was a simple fix once found. 
          </div>
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={example_code} className="HP-medPhoto" />
              <div className="HP-caption">Example WiFi code from Arduino</div>
            </div>
          </div>
        </div>
        <Slide>
          {codeSlide1.map((image) => <div className="HP-slideDiv" key={image.caption}>
              <div className="HP-photoObject">
                <img src={image.image} className="HP-slidePhotoLarge"/>
                <div className="HP-caption">{image.caption}</div>
              </div>
            </div>)}
        </Slide>
        <div className="HP-flex">
          <div className="HP-photoContent HP-half">
            <div className="HP-photoObject">
              <img src={API_endpoint} className="HP-medPhoto" style={{marginTop:"20px"}}/>
              <div className="HP-caption">New server API endpoint</div>
            </div>
            <div className="HP-photoObject">
              <img src={multi_site} className="HP-medPhoto"/>
              <div className="HP-caption">Multiple sites being pinged by input</div>
            </div>
          </div>
          <div className="HP-body HP-half">
            Now that I could successfully connect to my website, the next step was to create a dedicated way to do so. I went into my server codebase, written 
            in JavaScript, and added in a new API endpoint called "status" that would simply return a 200 status if the request made it to the server, a simple 
            and efficient way to ping the server and test if it is running. I added this new API endpoint to my server, and to the servers of two other sites 
            linked to my company, a testing site and a development site. I then modified my code to accept serial input to the microcontroller to allow me to 
            switch the site I was pinging based on the character entered. When a new site is chosen, the controller automatically pings the new site to check status. 
            If no new input is recieved, the controller will ping the server selected last once a minute to ensure continued uptime. A sample output of the switching site code can be seen below.
          </div>
        </div>
        <div className="HP-body">
          <br/><br/>The final step in my site checker was to create a physical device that could display the status of the selected site, since I didn't want to be checking 
          a serial interface every minute for the status. If I wanted that I could just refresh my webpage every minute!. I set out to build a simple circuit 
          with a LED, which would be lit when the site is active, off when the site is unresponsive. I first soldered pins onto my ESP32 so that I could access 
          the GPIO pins to power the LED. Next, I built a siple circuit with a GPIO pin (Pin 2) connected to the positive lead of a LED, which is in series with 
          a 1k Ohm resistor to limit current, and finally connected back to the chip's ground. This circuit allows me to write a value to the GPIO pin to turn the 
          LED on or off depending on my logic. Using yet another Arduino ESP32 example, I figured out how to use the ESP32 to write to a LED and triggered the 
          changes of the pin to my site status. With the LED code integrated into my WiFi status program, I now had a small circuit that can sit on my desk and 
          let me know if my website is up or down.
        </div>
        <div style={{marginTop: "40px"}} />
        <Slide>
          {codeSlide2.map((image) => <div className="HP-slideDiv" key={image.caption}>
              <div className="HP-photoObject">
                <img src={image.image} className="HP-slidePhotoLarge"/>
                <div className="HP-caption">{image.caption}</div>
              </div>
            </div>)}
        </Slide>
      </div>
    )
}

export default Week3;